module.exports = __webpack_public_path__ + "static/media/smokey-brisketeer.cd092aed.jpg";